import { Button, Container } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { Navigate, useParams } from 'react-router';
import { hasPermissions } from 'src/auth/guard/utils';
import { useAuthContext } from 'src/auth/hooks';
import Iconify from 'src/components/iconify/iconify';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import RestaurantEditPlanGroup from 'src/sections/restaurant/restaurant-edit-plangroup';

// ----------------------------------------------------------------------

export default function CreatePlanGroup() {
  const { user } = useAuthContext();
  const params = useParams();
  const { restaurantId } = params;
  if (!restaurantId) {
    return <Navigate to="/404" />;
  }

  return (
    <>
      <Helmet>
        <title> Dashboard: Create Plan Group</title>
      </Helmet>

      <Container maxWidth={false}>
        <Button
          size="small"
          variant="soft"
          component={RouterLink}
          href={
            hasPermissions(user, ['partners:misc:handle_multiple_restaurants'])
              ? paths.dashboard.restaurant.profile(restaurantId)
              : paths.dashboard.restaurant.plangroup.plangroups
          }
          startIcon={<Iconify icon="eva:arrow-ios-back-fill" width={16} />}
        >
          Back to Plan Group List
        </Button>

        <br />
        <br />
      </Container>

      <RestaurantEditPlanGroup restaurantId={restaurantId} id={undefined} />
    </>
  );
}
